var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrazoContexto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 123,
    viewBox: "0 0 118 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10405 34.0035C3.4033 34.5283 3.67698 35.0662 3.99775 35.5809L4.95795 37.1256C5.60198 38.1538 6.23066 39.1894 6.88834 40.2101L8.96776 43.2115L10.0105 44.7104L11.1272 46.1633L13.3625 49.0681L15.7421 51.8739L16.9347 53.2745C17.3327 53.7413 17.7708 54.1768 18.1872 54.6296L20.7168 57.3205C27.623 64.3668 35.5038 70.5761 44.0205 75.8657",
    stroke: "#FF7F41",
    strokeWidth: 5.16213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4579 53.9179C25.3359 54.9087 26.331 55.8001 27.2723 56.7367L28.7009 58.1279C29.1673 58.6008 29.693 59.0179 30.186 59.466C31.1902 60.344 32.1797 61.2379 33.1949 62.1047L36.334 64.6076L37.1185 65.2338C37.3805 65.4418 37.6605 65.6288 37.9306 65.8276L39.5654 67.0042C40.6569 67.7865 41.7288 68.593 42.8771 69.3028L46.2673 71.5014L49.7692 73.5392C54.4855 76.1722 59.3492 78.5972 64.4367 80.527C65.0698 80.7734 65.6901 81.0517 66.3337 81.2718L68.262 81.9427L70.1892 82.6145C70.511 82.7249 70.8301 82.8429 71.1539 82.9471L72.134 83.2374L76.0531 84.3999C77.3735 84.7412 78.7011 85.056 80.0243 85.3866C81.342 85.7415 82.6891 85.9758 84.0272 86.246C85.3668 86.5079 86.7011 86.8007 88.0569 86.9764C89.4085 87.1742 90.7568 87.3954 92.1109 87.5767L96.1877 88.0019C101.633 88.4601 107.107 88.5933 112.561 88.3247",
    stroke: "#59CBE8",
    strokeWidth: 10.1229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrazoContexto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TrazoContexto.8f831e42bcc05ec721bb31c1170ae0ec.svg";